import React from 'react';
import { Clock, CheckCircle, AlertCircle, TrendingUp, TrendingDown, Wallet, AlertTriangle, MinusCircle } from 'lucide-react';

// Pastilles de statut : arrondi d'un bouton (rounded-lg), bg-X-100 / text-X-800.
// Jamais la pilule — consigne du 07/10/2026, valable pour tout ecran KLASYS.
export const CaisseStatutBadge = ({ statut }) => {
  if (statut === 'validee') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-emerald-100 text-emerald-800">
        <CheckCircle size={12} className="mr-1" />
        Validée
      </span>
    );
  }
  if (statut === 'avec_observation') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-orange-100 text-orange-800">
        <AlertCircle size={12} className="mr-1" />
        Avec observations
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-yellow-100 text-yellow-800">
      <Clock size={12} className="mr-1" />
      En attente
    </span>
  );
};

/**
 * L'etat d'une caisse le jour meme.
 *
 * Cinq etats, et deux que l'ancien ecran ne pouvait pas montrer :
 * « oubliee » (restee ouverte un jour passe) et « pas ouverte » (personne
 * n'a ouvert de caisse aujourd'hui). Ce sont precisement les deux qu'on
 * cherche le matin.
 */
export const CaisseJourBadge = ({ etat }) => {
  if (etat === 'oubliee') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-amber-100 text-amber-900">
        <AlertTriangle size={12} className="mr-1" />
        Oubliée ouverte
      </span>
    );
  }
  if (etat === 'ouverte') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-[#246990]/10 text-[#246990]">
        <Wallet size={12} className="mr-1" />
        Ouverte
      </span>
    );
  }
  if (etat === 'remise_envoyee') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-yellow-100 text-yellow-800">
        <Clock size={12} className="mr-1" />
        Remise envoyée
      </span>
    );
  }
  if (etat === 'avec_observation') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-orange-100 text-orange-800">
        <AlertCircle size={12} className="mr-1" />
        Avec observations
      </span>
    );
  }
  if (etat === 'validee_centrale') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-emerald-100 text-emerald-800">
        <CheckCircle size={12} className="mr-1" />
        Validée
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-gray-100 text-gray-700">
      <MinusCircle size={12} className="mr-1" />
      Pas ouverte
    </span>
  );
};

export const DemandeDotationStatutBadge = ({ statut }) => {
  if (statut === 'validee') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-emerald-100 text-emerald-800">
        <CheckCircle size={12} className="mr-1" />
        Validée
      </span>
    );
  }
  if (statut === 'refusee') {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-800">
        <AlertCircle size={12} className="mr-1" />
        Refusée
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-yellow-100 text-yellow-800">
      <Clock size={12} className="mr-1" />
      En attente
    </span>
  );
};

export const MovementSensBadge = ({ sens }) => {
  const isEntree = sens === 'entree';
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium ${isEntree ? 'bg-emerald-100 text-emerald-800' : 'bg-red-100 text-red-800'}`}>
      {isEntree ? <TrendingUp size={12} className="mr-1" /> : <TrendingDown size={12} className="mr-1" />}
      {isEntree ? 'Entrée' : 'Sortie'}
    </span>
  );
};
